<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch} from 'src/typings';
    import type {SearchManagerState, SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import {exists} from 'shared/utils/custom-utils';
    import KpSearchAdditionalFilters from './KpSearchAdditionalFilters.svelte';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    let searchManagerState: Observable<SearchManagerState>;
    $: searchManagerState = searchManager.getState$();

    const handleSubmitSearch = () => {
        const currentFrontendParams = searchManager.getFrontendParams();

        searchManager.newSearchWithPartialParams({
            diacriticalPrefix: exists(currentFrontendParams.prefix) ? undefined : currentFrontendParams.diacriticalPrefix,
            prefix: currentFrontendParams.prefix
        });
    };
</script>

{#if exists($lastSearch)}
    <KpSearchAdditionalFilters filters={$lastSearch.forms}
                               params={$searchManagerState.frontendParams}
                               on:params-change={(event) => searchManager.setFrontendParams(event.detail)}
                               on:submit-search={handleSubmitSearch}/>
{/if}